














































































































































































































































































































































































































































































































import Vue from 'vue';
import api from '@/common/api';
import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';
import PageLoader from '@/common/components/PageLoader.vue';
import LoadingModal from '@/common/components/LoadingModal.vue';
import {
  DefaultLevel3Setting, initDefaultLevel3Setting,
} from '@/common/components/support/support.types';
import { initValidationErrors, ValidationErrors } from '@/common/validation/validation.types';

export default Vue.extend({
  data() {
    return {
      isSubmitting: false,
      newDefaultLevel3Setting: initDefaultLevel3Setting() as DefaultLevel3Setting,
      orderDateModal: false,
      validationErrors: initValidationErrors() as ValidationErrors,
    };
  },
  computed: {
    ...mapGetters(['isEnhancedDataEnabled']),
  },
  mounted() {
    if (typeof this.isEnhancedDataEnabled === 'undefined') {
      this.$store.dispatch('loadFeatures').then(() => {
        if (this.isEnhancedDataEnabled) {
          this.getData();
        } else {
          this.$router.push({ name: 'settings' });
        }
      });
    } else if (this.isEnhancedDataEnabled) {
      this.getData();
    } else {
      this.$router.push({ name: 'settings' });
    }
  },
  methods: {
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
    dollarFormattedValueOrZero(value:any) {
      return value ? value / 100 : 0;
    },
    init_values() {
      if (this.newDefaultLevel3Setting.orderDate !== '') {
        this.newDefaultLevel3Setting.orderDate = this.dateShortFormattedValue(
          this.newDefaultLevel3Setting.orderDate,
        );
      }

      this.newDefaultLevel3Setting.shippingAmount = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.shippingAmount,
      );
      this.newDefaultLevel3Setting.discountAmount = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.discountAmount,
      );
      this.newDefaultLevel3Setting.nationalTaxAmount = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.nationalTaxAmount,
      );
      this.newDefaultLevel3Setting.duty = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.duty,
      );
      this.newDefaultLevel3Setting.vatTaxAmount = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.vatTaxAmount,
      );
      this.newDefaultLevel3Setting.productCost = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.productCost,
      );
      this.newDefaultLevel3Setting.productTaxAmount = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.productTaxAmount,
      );
      this.newDefaultLevel3Setting.productDiscountAmount = this.dollarFormattedValueOrZero(
        this.newDefaultLevel3Setting.productDiscountAmount,
      );
    },
    getData() {
      api
        .get('/level-3-settings')
        .then((response:any) => {
          if (typeof response.data.data !== 'undefined') {
            this.newDefaultLevel3Setting = response.data.data!;
            this.init_values();
          }
          (this.$refs.loader as any).setReady();
        })
        .catch(() => {
          (this.$refs.loader as any).setReady();
        });
    },
    saveData() {
      if (!this.isValid()) {
        return;
      }

      this.newDefaultLevel3Setting.shippingAmount = Math.round(
        this.newDefaultLevel3Setting.shippingAmount * 100,
      );

      this.newDefaultLevel3Setting.discountAmount = Math.round(
        this.newDefaultLevel3Setting.discountAmount * 100,
      );

      this.newDefaultLevel3Setting.nationalTaxAmount = Math.round(
        this.newDefaultLevel3Setting.nationalTaxAmount * 100,
      );

      this.newDefaultLevel3Setting.duty = Math.round(
        this.newDefaultLevel3Setting.duty * 100,
      );

      this.newDefaultLevel3Setting.vatTaxAmount = Math.round(
        this.newDefaultLevel3Setting.vatTaxAmount * 100,
      );

      this.newDefaultLevel3Setting.productCost = Math.round(
        this.newDefaultLevel3Setting.productCost * 100,
      );

      this.newDefaultLevel3Setting.productTaxAmount = Math.round(
        this.newDefaultLevel3Setting.productTaxAmount * 100,
      );

      this.newDefaultLevel3Setting.productDiscountAmount = Math.round(
        this.newDefaultLevel3Setting.productDiscountAmount * 100,
      );

      if (this.newDefaultLevel3Setting.orderIdUseTransactionTd) this.newDefaultLevel3Setting.orderId = '';
      if (this.newDefaultLevel3Setting.poNumberUseTransactionId) this.newDefaultLevel3Setting.poNumber = '';
      if (this.newDefaultLevel3Setting.orderDescriptionUseTransactionId) this.newDefaultLevel3Setting.orderDescription = '';
      if (this.newDefaultLevel3Setting.orderDateUseTransactionDate) this.newDefaultLevel3Setting.orderDate = '';

      this.isSubmitting = true;
      api
        .post('/level-3-settings', this.newDefaultLevel3Setting)
        .then(() => {
          this.init_values();
          this.isSubmitting = false;
          this.$toasted.success('Default level 3 settings are saved successfully');
          (this.$refs.form as any).resetValidation();
        })
        .catch(({ response }: { response: any }) => {
          this.init_values();
          this.isSubmitting = false;

          if (response.status === 422) {
            const errors = response?.data?.errors;
            let msg: any = '';
            Object.keys(errors).forEach((key: any, idx: any) => {
              if (idx > 0) msg += '<br />';
              msg += `${errors[key]}`;
            });
            this.$toasted.error(msg);
          } else {
            this.$toasted.error(`There was a problem saving Default level 3 settings. (${response.status})`);
          }

          this.validationErrors = response.data.errors || {};
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    dateShortFormattedValue(value:any) {
      return DateTime.fromISO(value.toLocaleString()).toFormat('yyyy-MM-dd');
    },
  },
  components: {
    PageLoader,
    LoadingModal,
  },
});
